module.exports = __webpack_public_path__ + "static/media/vp-parkinsons.f79460c6.png";